import { FC, useCallback, useEffect, useState } from "react";
import { useAccount, useConnect, useDisconnect } from "wagmi";
import { useWeb3Modal } from "@web3modal/react";

import { useStoreDispatch, useStoreSelector } from "../../store/store";

import Button from "../UI/Button/Button";


const ConnectionButton: FC<{className?: string}> = ({className}) => {

	const { address } = useAccount();
	const { connectors, connect, error } = useConnect();
	const { disconnect: disconnectWallet } = useDisconnect();
	const { open } = useWeb3Modal();

	const { userAddress } = useStoreSelector(store => store.app);
	const { chrClientAddr } = useStoreSelector(store => store.chromia);
	const { setUserAddress, clearAppState, clearUIstate, clearChrState, clearModalsState } = useStoreDispatch();

	useEffect(() => {
		if (!error) {
			return;
		}
		if (error.message === "Connector not found") {
			window.open("https://metamask.io/download", "_blank");
		}
	}, [error]);

	const handleConnectClick = useCallback(() => {
		connect({
			connector: connectors.find((c) => c.id === "injected"),
		});
	}, [connect, connectors]);

	/* const loadChromia = async () => {
		const res = await (await getGtxClient()).query("ft4.get_all_assets", { page_size: 10, page_cursor: null });

		res.data.forEach(token => {
			getChromiaToken(token.id.toString('hex'), token.decimals, token.symbol, undefined);
		})
		// await getChrPools();
	} */

	useEffect(() => {
		
		if (address && !userAddress){
			setUserAddress(address);
		}
		if (!address && userAddress){
			clearAppState();
		}
		
		// loadChromia();
		// getPeriods();

		// eslint-disable-next-line
	}, [address, userAddress, chrClientAddr])

	const [isHovered, setIsHovered] = useState(false);	// not working

	/* useEffect(()=>{
		if (!userAddress){
			setIsHovered(false);
		}
	}, [userAddress]) */

	const disconnect = () => {
		disconnectWallet();
		clearAppState();
		clearChrState();
		clearModalsState();
		clearUIstate();
	}


	return address? (
		<Button
			action={disconnect}
			className={className}
			onMouseOut={() => setIsHovered(false)}
			onMouseOver={() => setIsHovered(true)}
		>
			{isHovered? 'Disconnect' : address.slice(0,6) + '...' + address.slice(-4)}
		</Button>
	) : (
		<Button
			// action={handleConnectClick}
			action={open}
			className={className}
		>
			Connect
		</Button>
	)
}

export default ConnectionButton;